import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResponseMessages } from '../models/global.model';
import { PpbToasterService } from './ppb-toaster.service';

@Injectable({
  providedIn: 'root'
})
export class HttpResponseToasterInterceptor implements HttpInterceptor {

  constructor(private toaster: PpbToasterService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        response => this.handleSuccess(response),
        error => this.handleError(error)
      )
    );
  }

  protected handleError(errorResponse: HttpErrorResponse): void {
    if (errorResponse.status >= 400 && errorResponse.status < 500) {
      if (errorResponse.error && errorResponse.error.error === 'invalid_grant') {
        return;
      }
    }

    const messageShown = this.toaster.openFor(errorResponse.error as ApiResponseMessages);
    if (!messageShown) {
      const errorMessage = this.errorMessageFrom(errorResponse);
      this.toaster.open(errorMessage, 'error');
    }
  }

  protected handleSuccess(response: HttpEvent<any>): void {
    if (response instanceof HttpResponse) {
      this.showToasterIfApplicable(response);
    }
  }

  private showToasterIfApplicable(response: HttpResponse<ApiResponseMessages>): void {
    if (response.body) {
      this.toaster.openFor(response.body);
    }
  }

  // noinspection JSMethodCanBeStatic
  private errorMessageFrom(errorResponse: HttpErrorResponse): string {
    if (errorResponse.status === 0) {
      return $localize`:@@shared.error_network:Wystąpił błąd komunikacji z ${errorResponse.url}. Sprawdź połączenie sieciowe
        i upewnij się, że używasz wspieranej przeglądarki w najnowszej wersji.`;
    }
    return $localize`:@@shared.error:Wystąpił błąd.`;
  }
}
